/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./ActionBlock.vue?vue&type=template&id=418e1d7e"
import script from "./ActionBlock.vue?vue&type=script&lang=js"
export * from "./ActionBlock.vue?vue&type=script&lang=js"
import style0 from "./ActionBlock.vue?vue&type=style&index=0&id=418e1d7e&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports